import { render, staticRenderFns } from "./tablaTargets.vue?vue&type=template&id=4e222b30&scoped=true&"
import script from "./tablaTargets.vue?vue&type=script&lang=js&"
export * from "./tablaTargets.vue?vue&type=script&lang=js&"
import style0 from "./tablaTargets.vue?vue&type=style&index=0&id=4e222b30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e222b30",
  null
  
)

export default component.exports